import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PracticeListService {
  getUnrestrictedLocations() {
    return of([
      'MED-086 MD-Havre De Grace',
      'MED-089 MD-Elkton',
      'MED-090 MD-Aberdeen',
      'MED-091 MD-Forest Hill',
      'MED-114 MD-Harford Mall',
      'MED-207 MD-Bel Air-Festival',
      'MED-252 MD-Nottingham Commons',
      'MED-463 PA-Havertown',
      'MED-553 PA-Exton Fairfield Center',
      'MED-554 PA-Parkway Shopping Center',
      'MED-555 PA-West Goshen Shopping Center',
      'MED-556 PA-The Shoppes at Longwood Village',
      'MED-557 PA-Caln Village Shopping Center',
      'MED-704 PA-Lansdale',
      'MED-705 PA-Chester Springs',
      'MED-072 NC-Laurinburg',
      'MED-419 NC-Morrisville',
      'MED-420 NC-Apex',
      'MED-428 NC-Fayetteville',
      'MED-504 NC-Wilmington-Hanover',
      'MED-509 NC-Wallace',
      'MED-510 NC-Leland',
      'MED-513 NC-Wilmington-Racine',
      'MED-521 NC-Cary-Crescent Commons',
      'MED-522 NC-Cary-Cornerstone',
      'MED-528 NC-Cary-Centrum',
      'MED-532 NC-Cary-Arboretum',
      'MED-533 NC-Wilmington-Mayfaire',
      'MED-534 NC-Aberdeen',
      'MED-539 NC-Wilmington-MonkeyJunction',
      'MED-545 NC-Holly Springs',
      'MED-072 NC-Laurinburg',
      'MED-073 SC-Greer',
      'MED-074 NC-Crabtree Valley Mall',
      'MED-083 NC-Greensboro-ElmStreet',
      'MED-094 NC-Huntersville',
      'MED-096 SC-Greenville-WadeHampton',
      'MED-198 NC-Clayton',
      'MED-224 VA-Beach Mall Drive',
      'MED-226 VA-Birchwood Shopping Center',
      'MED-227 VA-Kemps River Shopping Center',
      'MED-229 VA-Hampton',
      'MED-230 VA-Greenbrier Mall',
      'MED-231 VA-Portsmouth Blvd',
      'MED-232 VA-Monticello Marketplace Shoppes',
      'MED-233 VA-Patrick Henry Mall',
      'MED-266 NC-Cornelius',
      'MED-281 SC-Fort Mill',
      'MED-284 NC-Ballantyne East',
      'MED-339 NC-Greenville Blvd - Kirkland Dr',
      'MED-340 NC-Club Pines',
      'MED-341 NC-Greenville-Stantonsburg Rd',
      'MED-342 NC-Morehead City',
      'MED-345 NC-Williamston',
      'MED-347 SC-Pickens',
      'MED-401 NC-Arrowood',
      'MED-402 NC-CIC-Wells Fargo',
      'MED-403 NC-Uptown',
      'MED-404 NC-Randolph',
      'MED-405 NC-Independence Blvd',
      'MED-406 NC-Concord',
      'MED-407 NC-Kannapolis',
      'MED-408 NC-Mint Hill',
      'MED-409 NC-University',
      'MED-410 NC-Statesville',
      'MED-411 NC-South Blvd',
      'MED-412 NC-Henderson',
      'MED-413 NC-Garner-VandoraSprings',
      'MED-414 NC-Swansboro',
      'MED-415 NC-Ballantyne',
      'MED-417 NC-Olde Raleigh',
      'MED-419 NC-Morrisville',
      'MED-420 NC-Apex',
      'MED-421 SC-Rock Hill',
      'MED-422 NC-Roxboro',
      'MED-423 NC-Creedmoor Rd',
      'MED-425 NC-Gastonia-CourtDrive',
      'MED-426 NC-High Point',
      'MED-427 NC-Kernersville',
      'MED-428 NC-Fayetteville',
      'MED-429 SC-Mills Ave.',
      'MED-430 NC-Thomasville',
      'MED-437 NC-Kinston',
      'MED-439 NC-Winston-Salem',
      'MED-501 NC-Greenville Blvd',
      'MED-502 NC-Raleigh-NewBernAve',
      'MED-503 VA-South Hill',
      'MED-504 NC-Wilmington-Hanover',
      'MED-505 NC-Rocky Mount',
      'MED-506 NC-New Bern',
      'MED-507 NC-Washington',
      'MED-508 NC-Madison',
      'MED-509 NC-Wallace',
      'MED-510 NC-Leland',
      'MED-512 NC-Reidsville-PD',
      'MED-513 NC-Wilmington-Racine',
      'MED-514 NC-Eden',
      'MED-515 NC-Wake Forest',
      'MED-516 NC-Adams Farm',
      'MED-521 NC-Cary-Crescent Commons',
      'MED-522 NC-Cary-Cornerstone',
      'MED-523 NC-Zebulon-EastWake',
      'MED-524 NC-Louisburg',
      'MED-525 NC-North Raleigh',
      'MED-526 NC-Townridge',
      'MED-527 NC-Wakefield Commons',
      'MED-528 NC-Cary-Centrum',
      'MED-529 NC-Brier Creek Commons',
      'MED-530 NC-Village District',
      'MED-531 NC-Knightdale',
      'MED-532 NC-Cary-Arboretum',
      'MED-533 NC-Wilmington-Mayfaire',
      'MED-534 NC-Aberdeen',
      'MED-535 NC-Durham-RoxboroRd.',
      'MED-536 NC-Chapel Hill',
      'MED-537 NC-Raleigh-Leesville',
      'MED-538 NC-Burlington',
      'MED-539 NC-Wilmington-MonkeyJunct',
      'MED-540 NC-Garner-WhiteOakCrossin',
      'MED-541 NC-Durham-DukeOptical',
      'MED-542 NC-Durham-SouthSquare',
      'MED-543 NC-Durham-SouthPoint',
      'MED-544 NC-WakeForest-Capcom',
      'MED-545 NC-Holly Springs',
      'MED-547 NC-Greensboro-FriendlyCen',
      'MED-564 NC-Hendersonville',
      'MED-588 NC-Midtown East',
      'MED-598 VA-Denbigh',
      'MED-599 VA-Grafton',
      'MED-635 CO-Aurora',
      'MED-636 CO-Downtown Denver',
      'MED-637 CO-Highlands Ranch',
      'MED-638 CO-Lakewood',
      'MED-639 CO-Parker',
      'MED-640 CO-University Hills',
      'MED-642 CO-Boulder',
      'MED-685 NC-Raleigh-Green Rd',
      'MED-706 CO-South Colorado Blvd',
      'MED-720 CO-Centennial',
      'MED-735 NC-Arden',
      'MED-752 CO-Aurora-East Hampden Ave',
      'MED-757 CO-Aurora-S. Cornerstar Way',
      'MED-762 NC-Hendersonville-Four Seasons Blvd',
      'MED-717 CO-Englewood',
      'MED-150 CT-Ansonia',
      'MED-151 CT-Cheshire',
      'MED-152 CT-Danbury',
      'MED-153 CT-Fairfield',
      'MED-154 CT-Hamden',
      'MED-155 CT-Madison',
      'MED-156 CT-Naugatuck',
      'MED-157 CT-New Haven',
      'MED-158 CT-New Milford',
      'MED-159 CT-Norwalk',
      'MED-160 CT-Ridgefield',
      'MED-161 CT-Southbury',
      'MED-162 CT-Torrington',
      'MED-163 CT-Trumbull',
      'MED-164 CT-Waterbury Grandview',
      'MED-165 CT-Waterbury Lakewood',
      'MED-166 CT-Watertown',
      'MED-167 CT-Westport',
      'MED-220 CT-New Milford Shopping Plaza',
      'MED-223 CT-Winsted',
      'MED-287 VT-Stowe',
      'MED-318 VT-Williston',
      'MED-322 MA-Amherst',
      'MED-323 MA-Greenfield',
      'MED-335 CT-Newington',
      'MED-336 CT-Rocky Hill',
      'MED-337 CT-Vernon',
      'MED-349 CT-Avon',
      'MED-350 CT-Nutmeg Sq',
      'MED-351 CT-Newtown',
      'MED-474 MA-East Long Meadow-Main St',
      'MED-475 MA-Northampton-Hamp Plaza',
      'MED-476 MA-Springfield-Hamburg St',
      'MED-477 MA-Westfield',
      'MED-496 MA-Belmont',
      'MED-497 MA-Arlington',
      'MED-571 CT-Orange',
      'MED-571 CT-Orange',
      'MED-593 MA-State Street',
      'MED-594 MA-Wellesley',
      'MED-645 CT-Suffield',
      'MED-667 MA-Memorial Parkway',
      'MED-669 MA-Newton',
      'MED-670 MA-Brookline',
      'MED-672 MA-Quincy',
      'MED-693 CT-South Windsor',
      'MED-694 CT-Berlin Turnpike',
      'MED-696 CT-Southbury Green',
      'MED-719 MA-Northampton-Pleasant Street',
      'MED-749 MA-Danvers',
      'MED-750 MA-Topsfield',
      'MED-751 MA-Beverly-Cabot St',
      'MED-763 MA-Burlington',
      'MED-765 CT-Buckland Manchester',
      'MED-778 VT- Burlington Main Street',
      'MED-781 TX - Coal City',
      'MED-784 NH-Merrimack-Daniel Webster Highway',
      'MED-785 NH-Manchester-S. Willow Street',
      'MED-786 NH-Milford',
      'MED-787 NH-Hampton-Lafayette Road',
      'MED-788 NH-Windham-Indian Rock Road',
      'MED-789 NH-Epping',
      'MED-790 NH-Manchester-Intown',
      'MED-791 NH-Manchester-Sunbeam Mall',
      'MED-799 NY-Brewster',
      'MED-867 NY-Yonkers',
      'MED-872 NY-Plainview-Woodbury',
      'MED-289 LA-Uptown',
      'MED-290 LA-Elmwood',
      'MED-291 LA-Mandeville',
      'MED-292 LA-Metairie',
      'MED-293 LA-Chateau Commons',
      'MED-294 LA-Boutte',
      'MED-299 AL-Hoover',
      'MED-300 AL-Colonnade',
      'MED-301 AL-Inverness',
      'MED-303 AL-Southside',
      'MED-304 AL-Mountain Brook',
      'MED-307 AL-Five Points West',
      'MED-308 AL-Trussville',
      'MED-310 AL-Parkway East',
      'MED-311 AL-Providence',
      'MED-312 AL-Madison',
      'MED-313 AL-Whitesburg Dr.',
      'MED-315 AL-Montgomery',
      'MED-352 LA-Uptown-Magazine St',
      'MED-392 AL-Pelham Parkway',
      'MED-393 AL-Calera',
      'MED-394 AL-Clanton',
      'MED-395 TN-Memphis-Moriah Road',
      'MED-396 TN-Memphis Downtown',
      'MED-442 AL-Decatur',
      'MED-446 TN-Humboldt',
      'MED-447 TN-Dyersburg',
      'MED-448 TN-Jackson',
      'MED-449 TN-Ripley',
      'MED-465 TX-Houston-Willowbrook',
      'MED-484 AR-Arkadelphia',
      'MED-485 AR-De Queen',
      'MED-486 AR-Hope',
      'MED-487 AR-Magnolia',
      'MED-488 AR-Mena',
      'MED-489 AR-Nashville',
      'MED-490 OK-Broken Bow',
      'MED-491 OK-Idabel',
      'MED-492 TX-Mt. Pleasant',
      'MED-493 TX-Texarkana-Richmond Road',
      'MED-494 AR-Texarkana-49th Street',
      'MED-498 AL-Trussville-N. Chalkville Rd',
      'MED-548 TN-Bartlett',
      'MED-549 TN-Memphis-Regalia',
      'MED-550 TN-Memphis-Cordova',
      'MED-551 TN-Memphis-University',
      'MED-552 TN-Memphis-Winchester',
      'MED-561 AR-EL Dorado',
      'MED-572 TX-Watauga',
      'MED-578 AL-Cullman',
      'MED-585 TX-Missouri City',
      'MED-641 TX-Longview',
      'MED-651 TX-Irving',
      'MED-652 TX-North Richland Hills',
      'MED-653 TX-Richardson',
      'MED-654 TX- Prosper',
      'MED-655 TX-Carrolton-Trinity Mill Rd',
      'MED-656 TX-Dallas-LBJ Freeway',
      'MED-657 TX-Park Forest',
      'MED-658 TX-Plano-Midway Rd',
      'MED-659 TX-Prestonwood',
      'MED-660 TX-Corsicana',
      'MED-661 TX-North Arlington',
      'MED-662 TX-Carrollton-Hebron Pkwy',
      'MED-663 LA-Houma',
      'MED-664 TX-Murphy',
      'MED-665 TX-Plano-Parker Rd',
      'MED-666 TX-McKinney',
      'MED-668 TN-Columbia',
      'MED-673 TX-College Station',
      'MED-674 TX-College Station South',
      'MED-675 TX-Bryan',
      'MED-676 TX-Beaumont',
      'MED-677 TX-Southlake Town Square',
      'MED-678 TX-Tanglewood',
      'MED-682 TN-Nolensville',
      'MED-684 TX-Eagle Mountain',
      'MED-687 TX-Greenville',
      'MED-688 TX-N. Beltline Rd',
      'MED-697 TX-Quarry Market',
      'MED-699 TN-Bellevue',
      'MED-708 TX-Houston-South Voss',
      'MED-709 TX-Katy-Grand Parkway',
      'MED-710 TX-South Katy',
      'MED-711 TN-Germantown-Exeter Village',
      'MED-712 TN-Collierville',
      'MED-713 TX-San Marcos',
      'MED-715 TX-Orange',
      'MED-716 TX-Silsbee',
      'MED-722 TX-Parkdale Mall',
      'MED-726 TX-Forney',
      'MED-727 TX-Lakewood',
      'MED-728 TX-Hurst',
      'MED-729 TX-Keller',
      'MED-730 TX-Roanoke',
      'MED-732 TX-Westchase',
      'MED-734 TX-New Braunfels',
      'MED-737 TX-Grand Prairie',
      'MED-739 TX-Park Cities',
      'MED-741 TX-Burleson',
      'MED-742 TX-Cedar Hill',
      'MED-743 TX-Granbury',
      'MED-746 AR-Sherwood',
      'MED-753 TX-Dripping Springs',
      'MED-754 TX-Bedford',
      'MED-755 TX-Grapevine',
      'MED-756 TX-Grand Prairie - Pioneer Pkwy',
      'MED-761 TX-Spring Klein',
      'MED-764 TX-Sherwood Way',
      'MED-777 TX-Austin-Angus RD',
      'MED-796 TX-Clear Lake City Blvd',
      'MED-798 TX- Cy Fair',
      'MED-860 Tx-Cinco Ranch',
      'MED-861 TX-Houston-Northwest FWY',
      'MED-172 IL-Andersonville',
      'MED-173 IL-Evanston Central St.',
      'MED-174 IL-Chicago Avenue',
      'MED-175 IL-Evanston Dempster St.',
      'MED-176 IL-East Madison',
      'MED-177 IL-Elmhurst',
      'MED-179 IL-Grayslake',
      'MED-180 IL-Clybourn Commons',
      'MED-182 IL-Highland Park',
      'MED-184 IL-Hinsdale',
      'MED-186 IL-Lakeview',
      'MED-188 IL-Vernon Hills',
      'MED-189 IL-Lincoln Square',
      'MED-190 IL-Naperville',
      'MED-191 IL-Oak Park',
      'MED-192 IL-Old Town',
      'MED-193 IL-North Center',
      'MED-194 IL-West Loop',
      'MED-255 IL-Joliet',
      'MED-257 IL-Oak Lawn',
      'MED-259 IL-Calumet',
      'MED-264 IL-Naperville- East Ogden Ave',
      'MED-265 IL-Gurnee',
      'MED-273 IL-Lansing',
      'MED-288 IL-Minooka',
      'MED-298 IL-Machesney Park',
      'MED-333 IL-Batavia',
      'MED-334 IL-Bolingbrook',
      'MED-431 IL-Elk Grove Village',
      'MED-432 IL-Lake Zurich',
      'MED-433 IL-Park Ridge',
      'MED-434 IL-West Dundee',
      'MED-440 WI-Kenosha',
      'MED-441 IL-Lincoln Park-North Sheridan',
      'MED-499 WI-New Berlin',
      'MED-559 IL-N. Michigan Ave',
      'MED-565 WI-Fox Point',
      'MED-566 WI-Mequon',
      'MED-567 WI-Fredonia',
      'MED-586 WI-West Side',
      'MED-590 WI-S. Monroe Ave',
      'MED-680 IL-Roselle',
      'MED-698 WI-Downtown Racine',
      'MED-701 WI-Cudahy',
      'MED-714 WI-Grange-South Milwaukee',
      'MED-725 WI-Wauwatosa',
      'MED-738 WI-Elm Grove',
      'MED-747 IL-Des Plaines',
      'MED-758 IL-Downers Grove',
      'MED-766 WI-Sheboygan',
      'MED-869 WI- Wisconsin Rapids',
      'MED-804 IN-Angola',
      'MED-805 IN-Elkhart-Cassopolis St',
      'MED-806 IN-Kendallville',
      'MED-807 MI-Allen Park',
      'MED-808 MI-Ann Arbor',
      'MED-809 MI-Ann Arbor East',
      'MED-810 MI-Battle Creek',
      'MED-811 MI-Benton Harbor',
      'MED-812 MI-Breton Village',
      'MED-813 MI-Grand Rapids-Cascade Rd',
      'MED-814 MI-Charlotte',
      'MED-815 MI-Coldwater',
      'MED-816 MI-Grand Haven',
      'MED-817 MI-Grand Rapids',
      'MED-818 MI-Grand Rapids-Plainfield',
      'MED-819 MI-Grandville',
      'MED-820 MI-Hastings',
      'MED-821 MI-Holland Central',
      'MED-822 MI-Holland North',
      'MED-823 MI-Holland South',
      'MED-824 MI-Ionia',
      'MED-825 MI-Jackson East',
      'MED-826 MI-Jackson West',
      'MED-827 MI-Jenison',
      'MED-828 MI-Jonesville-Hillsdale',
      'MED-829 MI-Kalamazoo-Downtown',
      'MED-830 MI-Kalamazoo-Drake Road',
      'MED-831 MI-Kalamazoo-East Side',
      'MED-832 MI-Kalamazoo-Oakwood',
      'MED-833 MI-Kalamazoo-West',
      'MED-834 MI-Kalamazoo-Westnedge Hill',
      'MED-835 MI-Kentwood',
      'MED-836 MI-Kentwood South',
      "MED-837 MI-Knapp's Crossing",
      'MED-838 MI-Lansing',
      'MED-839 MI-Livonia',
      'MED-840 MI-Muskegon',
      'MED-841 MI-Muskegon-Fruitport',
      'MED-842 MI-Niles',
      'MED-843 MI-Norton Shores',
      'MED-844 MI-Otsego-Plainwell',
      'MED-845 MI-Plainfield North',
      'MED-846 MI-Plymouth',
      'MED-847 MI-Portage',
      'MED-848 MI-Rockford',
      'MED-849 MI-Saline',
      'MED-850 MI-Southgate',
      'MED-851 MI-St. Joseph',
      'MED-852 MI-Sturgis',
      'MED-853 MI-Three Rivers',
      'MED-854 MI-Walker',
      'MED-855 MI-Walker-Standale',
      'MED-856 MI-Woodhaven',
      'MED-857 MI-Wyoming',
      'MED-076 GA-Thomasville',
      'MED-077 FL-Crawfordville',
      'MED-078 FL-Timberlane Road',
      'MED-079 FL-Parkway',
      'MED-080 GA-Albany',
      'MED-082 FL-Perry',
      'MED-111 FL-St Johns',
      'MED-112 FL-Jacksonville-Normandy',
      'MED-113 FL-St Augustine',
      'MED-126 FL-Kissimmee',
      'MED-127 FL-Plant City',
      'MED-128 FL-Poinciana',
      'MED-129 FL-Haines City',
      'MED-131 FL-Bartow',
      'MED-132 FL-Sebring',
      'MED-133 FL-Clermont',
      'MED-134 FL-Winter Haven',
      'MED-135 FL-South Lakeland',
      'MED-136 FL-Central Lakeland',
      'MED-137 FL-North Lakeland',
      'MED-169 FL-Oakleaf Town Center',
      'MED-201 FL-Gainesville',
      'MED-202 FL-Ocala',
      'MED-203 FL-Triple Crown',
      'MED-216 FL-Riverside',
      'MED-219 FL-Miccosukee Road',
      'MED-221 FL-Middleburg',
      'MED-222 GA-Columbus',
      'MED-254 FL-Orange Park Place Plaza',
      'MED-263 FL-Jacksonville-Atlantic Blvd',
      'MED-267 FL-Lake Wales',
      'MED-274 FL-Palm Harbor',
      'MED-275 FL-St. Petersburg-Tyrone',
      'MED-276 FL-Tampa-West Bearss',
      'MED-277 FL-St. Petersburg-4th Street',
      'MED-278 FL-Clearwater Mall',
      'MED-279 FL-Seminole',
      'MED-317 FL-Boynton Beach',
      'MED-319 FL-Boca Raton',
      'MED-320 FL-Palm Beach Gardens',
      'MED-331 FL-Mission Bay',
      'MED-399 FL-Wilton Manors',
      'MED-444 FL-Jacksonville Beach',
      'MED-464 GA-Columbus-17th Avenue',
      'MED-560 FL-Old St. Augustine Rd',
      'MED-595 Midtown Tampa',
      'MED-597 FL-Mandarin',
      'MED-646 FL-East Broward',
      'MED-691 FL-Leesburg',
      'MED-692 FL-The Villages',
      'MED-745 FL-South Tampa',
      'MED-769 FL-Port St John',
      'MED-858 MI-Belleville RD',
      'MED-859 MI-Canton- N. Canton Center Rd',
      'MED-863 FL-Jacksonville Eye Care Center',
      'MED-003 MD-Chevy Chase',
      'MED-005 DC-L Street',
      'MED-006 MD-Forestville',
      'MED-007 MD-Fallsgrove',
      'MED-009 DC-Dupont Circle',
      'MED-011 MD-Olney',
      'MED-015 MD-Silver Spring',
      'MED-023 MD-Oxon Hill',
      'MED-024 MD-Rockville Pike',
      'MED-028 VA-Alexandria-DukeSt.',
      'MED-030 MD-Aspen Hill',
      'MED-031 MD-Bethesda',
      'MED-032 MD-Greenbelt Rd.',
      'MED-035 MD-Germantown',
      'MED-038 DC-Eye Street',
      'MED-039 MD-Cabin John',
      'MED-041 MD-Kentlands',
      'MED-042 MD-Annapolis',
      'MED-043 DC-Pennsylvania Ave',
      'MED-047 MD-Columbia',
      'MED-049 MD-Hyattsville',
      'MED-050 MD-Bowie',
      'MED-052 VA-Alexandria-Rt.1',
      'MED-053 MD-Eldersburg',
      'MED-054 MD-Pikesville',
      'MED-058 MD-Dunkirk',
      'MED-060 MD-Prince Frederick',
      'MED-061 MD-Canton Crossing',
      'MED-062 MD-California-Lexington Park',
      'MED-063 MD-Charlotte Hall',
      'MED-064 MD-Towson',
      'MED-065 MD-Waldorf',
      'MED-067 DC-Gallery Place',
      'MED-068 MD-Hunt Valley',
      'MED-069 MD-Laurel',
      'MED-071 MD-Ellicott City',
      'MED-086 MD-Havre De Grace',
      'MED-089 MD-Elkton',
      'MED-090 MD-Aberdeen',
      'MED-091 MD-Forest Hill',
      'MED-099 MD-California-EyeCarePlaz',
      'MED-100 MD-Bowie-GatewayCenter',
      'MED-103 MD-Waldorf-CrainHighway',
      'MED-104 MD-Germantown-TownSquare',
      'MED-114 MD-Tollgate Marketplace',
      'MED-116 DE-Dover',
      'MED-117 DE-West Dover',
      'MED-118 DE-Milford',
      'MED-119 DE-Smyrna',
      'MED-120 DE-Seaford',
      'MED-121 DE-Georgetown',
      'MED-122 DE-Middletown',
      'MED-123 DE-Millville',
      'MED-124 DE-Bear',
      'MED-125 DE-Wilmington-KirkwoodHwy',
      'MED-197 MD-La Plata',
      'MED-204 MD-Parkville',
      'MED-205 MD-Annapolis-Riva Road',
      'MED-206 MD-Arundel Mills',
      'MED-207 MD-Bel Air-Festival',
      'MED-211 MD-Salisbury',
      'MED-214 MD-Westminster',
      'MED-225 DC-Cathedral Commons',
      'MED-234 MD-La Vale',
      'MED-240 PA-Greencastle',
      'MED-241 PA-Chambersburg - Wayne Ave.',
      'MED-243 PA-Carlisle Commons',
      'MED-244 PA-Carlisle-York Road',
      'MED-245 PA-Shippensburg',
      'MED-246 PA-Waynesboro',
      'MED-252 MD-Nottingham Commons',
      'MED-253 MD-Easton',
      'MED-258 PA-Chambersburg-Gateway Center',
      'MED-260 PA-East York-East Market St',
      'MED-261 PA-Manchester Town Center',
      'MED-262 PA-Shrewsbury',
      'MED-295 PA-Fairless Hills',
      'MED-296 PA-Southampton',
      'MED-297 PA-Newtown',
      'MED-353 PA-Hanover',
      'MED-354 PA-Lancaster',
      'MED-355 PA-Newtown-Pheasant Run',
      'MED-398 PA-Trappe',
      'MED-436 VA-Alexandria-Old Town',
      'MED-438 PA-Doylestown',
      'MED-450 WV-Parkersburg',
      'MED-451 WV-Spencer',
      'MED-452 PA-New Kensington',
      'MED-454 PA-Pittsburgh-North Hills',
      'MED-455 PA-Pittsburgh-Oakland',
      'MED-456 PA-Beaver Falls',
      'MED-457 PA-Vanport',
      'MED-458 PA-Chippewa',
      'MED-459 PA-Moon Township',
      'MED-461 MD-Silver Spring-Four Corners',
      'MED-462 PA-Oak Park Mall',
      'MED-463 PA-Havertown',
      'MED-553 PA-Exton Fairfield Center',
      'MED-554 PA-Parkway Shopping Center',
      'MED-555 PA-West Goshen Shopping Center',
      'MED-556 PA-The Shoppes at Longwood Village',
      'MED-557 PA-Caln Village Shopping Center',
      'MED-558 PA-Bethlehem',
      'MED-570 WV-Keyser',
      'MED-579 WV-Bridgeport',
      'MED-580 WV-Buckhannon',
      'MED-581 PA-Dallastown',
      'MED-582 PA-East York-Eastern Blvd',
      'MED-583 PA-Carlisle-White Street',
      'MED-584 PA-Lititz',
      'MED-587 WV-Fairmont',
      'MED-591 PA-Rodi',
      'MED-592 PA-Holiday Park',
      'MED-596 PA-Indian Springs',
      'MED-647 MD-Bel Pre Rd',
      'MED-648 PA-Boothwyn',
      'MED-683 MD-College Park-Baltimore Avenue',
      'MED-689 PA-Latrobe',
      'MED-690 PA-Somerset',
      'MED-700 PA-Monroeville',
      'MED-704 PA-Lansdale',
      'MED-705 PA-Chester Springs',
      'MED-744 PA-Strasburg',
      'MED-748 PA-Whitehall',
      'MED-770 MD- Severna Park',
      'MED-794 PA- carslile pike',
      'MED-868 PA-Oxford',
      'MED-002 VA-Burke',
      'MED-004 VA-Reston',
      'MED-008 VA-Potomac Mills',
      'MED-012 VA-Clarendon',
      'MED-014 VA-Fairfax',
      'MED-016 VA-Springfield',
      'MED-019 VA-Gainesville',
      'MED-020 VA-Vienna',
      'MED-022 VA-Ballston',
      'MED-025 VA-Stafford',
      'MED-026 VA-Lorton',
      'MED-027 VA-Leesburg',
      'MED-029 VA-Sterling',
      'MED-034 VA-Centreville',
      'MED-040 VA-Bristow',
      'MED-044 VA-Liberia',
      'MED-046 MD-Frederick',
      'MED-048 VA-Falls Church',
      'MED-051 VA-Merrifield',
      'MED-055 VA-Pentagon City',
      'MED-056 VA-McLean',
      'MED-057 VA-Winchester',
      'MED-059 VA-Front Royal',
      'MED-066 VA-One Loudoun',
      'MED-070 VA-Westfield Road',
      'MED-084 VA-South Riding',
      'MED-092 VA-Harrisonburg-Parkview',
      'MED-097 VA-Fredericksburg-SouthPo',
      'MED-098 VA-Tysons Corner',
      'MED-107 VA-Harrisonburg-Reservoir',
      'MED-108 VA-Warrenton',
      'MED-109 VA-Staunton',
      'MED-115 VA-Baileys Crossroads',
      'MED-149 MD-Thurmont',
      'MED-170 VA-Charlottesville-Sachem',
      'MED-171 VA-Charlottesville-Pantops',
      'MED-235 MD-Hagerstown-Valley Mall',
      'MED-236 MD-Hagerstown-The Lyles Center',
      'MED-237 MD-Hagerstown-Dual Highway',
      'MED-238 MD-Francis Scott Key Mall',
      'MED-247 VA-Leesburg-Battlefield Shopping Center',
      'MED-248 VA-Winchester - Pleasant Valley Rd',
      'MED-249 WV-Martinsburg - Foxcroft Ave',
      'MED-250 WV-Martinsburg - Williamsport Pike',
      'MED-251 WV-Charles Town',
      'MED-256 VA-Culpeper',
      'MED-272 VA-Herndon',
      'MED-280 VA-Chantilly',
      'MED-400 VA-Lynchburg',
      'MED-466 VA-Lynchburg-Timberlake',
      'MED-467 VA-Lynchburg-Langhorne',
      'MED-468 VA-Appomattox',
      'MED-471 VA-Charlottesville-5th St Station',
      'MED-472 VA-Charlottesville- Barracks Rd',
      'MED-473 VA-Charlottesville- Hollymead Town Ctr',
      'MED-076 GA-Thomasville',
      'MED-080 GA-Albany',
      'MED-085 GA-Waycross Mall',
      'MED-095 GA-Woodstock Mall',
      'MED-138 GA-Alpharetta',
      'MED-139 GA-Cartersville',
      'MED-140 GA-Canton',
      'MED-141 GA-Woodstock',
      'MED-142 GA-Brookhaven',
      'MED-144 GA-Cumberland Pointe',
      'MED-145 GA-Lawrenceville',
      'MED-146 GA-Suwanee',
      'MED-147 GA-Sandy Springs',
      'MED-148 GA-Lindbergh Plaza',
      'MED-168 GA-Briarcliff Village',
      'MED-217 SC-Manning',
      'MED-218 SC-Long Point',
      'MED-222 GA-Columbus',
      'MED-268 SC-North Charleston',
      'MED-282 GA-Chatsworth',
      'MED-285 GA-Macon',
      'MED-321 TN-Chattanooga-Market Street',
      'MED-348 GA-McDonough',
      'MED-397 GA-Kennesaw',
      'MED-435 GA-Bremen',
      'MED-445 GA-Savannah-Hodgson Memorial Dr.',
      'MED-464 GA-Columbus-17th Avenue',
      'MED-495 OH-Dayton-N Main Street',
      'MED-563 OH-Toledo',
      'MED-568 GA-Midtown Atlanta',
      'MED-569 OH-Marion',
      'MED-575 OH-Oakwood',
      'MED-577 SC - Shell Point',
      'MED-601 GA-Statesboro',
      'MED-603 GA-Rincon',
      'MED-604 GA-Brunswick',
      'MED-605 GA-Kingsland',
      'MED-606 GA-Dublin',
      'MED-607 GA-Augusta',
      'MED-608 GA-Martinez',
      'MED-610 GA-Warner Robins',
      'MED-611 GA-Milledgeville',
      'MED-612 GA-Pooler',
      'MED-613 GA-Perry',
      'MED-614 KY-Cold Spring',
      'MED-615 KY-Crescent Springs',
      'MED-616 KY-Florence',
      'MED-617 KY-Newport',
      'MED-618 OH-Beechmont',
      'MED-619 OH-Colerain',
      'MED-621 OH-Fairfield',
      'MED-622 OH-Glenway',
      'MED-623 OH-Hamilton',
      'MED-624 OH-Hyde Park',
      'MED-625 OH-Kenwood',
      'MED-626 OH-Liberty',
      'MED-627 OH-Miamisburg',
      'MED-628 OH-Middletown',
      'MED-629 OH-Milford',
      'MED-631 OH-Symmes Township',
      'MED-632 OH-Tri-County',
      'MED-634 OH-Xenia',
      'MED-643 OH-Beachwood',
      'MED-644 OH-Hudson',
      'MED-671 OH-Limestone Street',
      'MED-681 OH-Perrysburg',
      'MED-686 OH-Westgate',
      'MED-695 OH-Norwalk',
      'MED-702 GA-Bridgemill',
      'MED-703 GA-Roswell',
      'MED-721 GA-Manchester-Warm Springs Highway',
      'MED-740 OH-Canal Fulton',
      'MED-760 OH-Bellevue',
      'MED-767 OH-Wadsworth',
      'MED-768 OH-North Canton',
      'MED-792 OH-Columbus-W. Henderson Rd',
      'MED-797 GA-Acworth-Cedarcrest Rd',
      'MED-865 OH-Ashville',
      'MED-875 OH-Salem-E. State St',
      'MED-899 SC-Charleston-South Windemere',
      'MED-356 IN-Anderson',
      'MED-357 IN-Avon',
      'MED-359 IN-Bloomington South',
      'MED-360 IN-Broad Ripple',
      'MED-362 IN-Carmel',
      'MED-365 IN-Downtown',
      'MED-366 IN-Eagle Creek',
      'MED-367 IN-Elkhart',
      'MED-368 IN-Fishers',
      'MED-369 IN-Fort Wayne',
      'MED-370 IN-Greenwood',
      'MED-371 IN-Irvington',
      'MED-373 IN-Lafayette',
      'MED-374 IN-Lebanon',
      'MED-375 IN-Merrillville',
      'MED-376 IN-Michigan City',
      'MED-377 IN-Mishawaka',
      'MED-378 IN-Noblesville',
      'MED-380 IN-Noblesville West',
      'MED-381 IN-Olio',
      'MED-382 IN-Plainfield',
      'MED-383 IN-Shadeland',
      'MED-384 IN-South Bend',
      'MED-385 IN-Southport',
      'MED-386 IN-Spencer',
      'MED-387 IN-Terre Haute',
      'MED-389 IN-Westfield',
      'MED-390 IN-Willow Lake',
      'MED-391 IN-Zionsville',
      'MED-469 IN-Bloomington-Jackson Creek Shopping Pl',
      'MED-470 IN-Ellettsville',
      'MED-478 IN-Chesterton',
      'MED-479 IN-Crown Point',
      'MED-480 IN-La Porte',
      'MED-481 IN-Portage',
      'MED-483 IN-Valparaiso-N. Calumet',
      'MED-562 IN-Carmel-E. 146th',
      'MED-573 IN-Geist',
      'MED-574 MI-Shelby Township',
      'MED-576 MI-Cascades',
      'MED-679 IN-Fall Creek',
      'MED-718 IN-Fishers-Lantern Road',
      'MED-733 IN-Columbus-Washington St',
      'MED-772 MI-Mason-South Cedar St',
      'MED-773 MI-Fort Gratiot-24th Ave',
      'MED-782 MI-Brighton-West Grand River Ave',
      'MED-783 MI-Battle Creek-Tower Road',
      'MED-858 MI-Belleville-Belleville Rd',
      'MED-859 MI-Canton-N. Canton Center Rd',
      'MED-874 MI-Wyandotte-Biddle Ave',
      'MED-888 MI-Battle Creek-North Ave',
    ]);
  }
}
